import { useContext } from 'react';
import { useTheme as useStyledTheme } from 'styled-components';
import { ThemeContext } from './themeContext';
export function useTheme() {
    return useStyledTheme();
}
export function useRootTheme() {
    const rootTheme = useContext(ThemeContext);
    if (!rootTheme) {
        throw new Error('useRootTheme(): missing context value');
    }
    return rootTheme;
}
//# sourceMappingURL=hooks.js.map